<template>
  <div class="c-footer">
    <FHFooter :hide-social="true" />
  </div>
</template>

<script>
import FHFooter from '@forlagshuset/v-small-footer'

export default {
  components: {
    FHFooter,
  },
}
</script>